import { Splide } from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function() {
    const sliders = document.querySelectorAll(".splide-section_events-slider");

    // check if sliders are already initialized or not

    if (sliders.length === 0) {
        return;
    }

    // initialize every slider

    sliders.forEach(function(slider) {
        // check if slider has class .is-initialized
        if (slider.classList.contains("is-initialized")) {
            return;
        }

        const eventsSlider = new Splide(slider, {
            type: "slide",
            rewind: true,
            arrows: false,
            pagination: false,
            perPage: 4,
            perMove: 1,
            breakpoints: {
                768: {
                    perPage: 2,
                    perMove: 1
                },
                1024: {
                    perPage: 2,
                    perMove: 1
                }
            }
        });

        let bar = eventsSlider.root.querySelector(
            ".events-slider__progress-bar"
        );

        // Updates the bar width whenever the carousel moves:
        eventsSlider.on("mounted move", function() {
            var end = eventsSlider.Components.Controller.getEnd() + 1;
            var rate = Math.min((eventsSlider.index + 1) / end, 1);
            bar.style.width = String(100 * rate) + "%";
        });

        eventsSlider.mount();

        function move(slider) {
            // move the slider to the next slide
            slider.go("+1");
        }

        // check if the parent of the slider has button with id events_next

        let parentElement = slider.closest('.events-slider');
        let button = parentElement.querySelector("#events_next");

        if (button) {
            button.addEventListener("click", () => {
                move(eventsSlider);
            });
        }
    });
});
